import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs-cmp"},[_c('div',{staticClass:"buttons-container"},_vm._l((_vm.tabs),function(tab,index){return _c('button',{key:index,staticClass:"tab-btn",on:{"click":(e)=>_vm.renderTabs(e,tab.base,tab.path)}},[_vm._v(_vm._s(tab.name)),_c(VIcon,{staticClass:"icon",attrs:{"icon":""}},[_vm._v(_vm._s(tab.icon))])],1)}),0),_c('div',{staticClass:"current-tab"},[_c('RouterView')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }